import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import { Link } from "react-router-dom";
import { AttributeContext } from "./AttributeContext";
import Label from "../../Common/components/Label";
import AttributeValues from "./Componets/AttributeValues";
import ABS from "./Componets/ABS";
import AttributeConstraint from "./Componets/AttributeConstraint";
import Category from "./Componets/Category";
import { toast } from "react-toastify";
import Utils from "../../../Common/Utils";
import { getAbsConstraintsByAttributeID, getAssociatedCategoriesByAttributeID, getConstraintsByAttributeID, listAttributeValuesByAttributeID } from "api/Attributes";

import LoadingSuccessErrorAlert from "./Componets/LoadingSuccessErrorAlert";
import AttributeDetails from "./Componets/AttributeDetails";
import { generateAttributeConstraintObject } from "./constants";
import { ABS_SELECTION, CF_SELECTION } from "./AttributeConstants";

// let disableButton = false;
function AddEditViewAttr({ setAttrListApiCompleted }) {
  const appContext = useContext(AppContext);
  const attributeContextData = useContext(AttributeContext);
  const industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;

  const [finalAttributeConstraint, setFinalAttributeConstraint] =
    useState(null);
  const [finalAttributeValues, setFinalAttributeValues] = useState([]);
  const [finalABSValue, setFinalABSValue] = useState(null);
  const [finalCFValue, setFinalCFValue] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [prevSelectedCategory, setPrevSelectedCategory] = useState([]);
  const [associatedCategory, setAssociatedCategory] = useState(null);
  const [attributeResponse, setAttributeResponse] = useState(null);
  const [disableButtons, setDisableButtons] = useState(true);

  const { editingItem, setListReloadCounter, setEditingItem, attributeId } = useContext(AttributeContext);
  const [loading, setLoading] = useState({ status: "", message: "", });
  const [loadingInfo, setLoadingInfo] = React.useState({ status: "", message: "", });

  const initialStateObject = { id: "", name: "", description: "", active: true, };
  const validationOptions = { name: { required: true, minLength: 2, maxLength: 60, type: "alnum_with_spaces", }, };
  const [attributeDetail, setAttributeDetail] = useState(initialStateObject);
  const [attributeDetailCopy, setAttributeDetailCopy] = useState(initialStateObject);

  async function load_attribute_detail() {
    setAttributeResponse(null);
    setLoadingInfo({ status: "", message: "", });
    setLoading({ status: "Loading", message: "Loading Attribute Details", });
    const api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const res = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list/${editingItem.id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (editingItem.form === "duplicate") {
        res.data.data[0].name = "[Duplicate] " + res.data.data[0].name;
        res.data.data[0].description =
          "[Duplicate] " + res.data.data[0].description;
        await setAttributeDetail(res.data.data[0]);
        await setAttributeDetailCopy(res.data.data[0]);
      } else {
        await setAttributeDetail(res.data.data[0]);
        await setAttributeDetailCopy(res.data.data[0]);
      }
      if (
        res.data.data[0].attribute_value &&
        res.data.data[0].attribute_value.data
      ) {
        setFinalAttributeValues(res.data.data[0].attribute_value.data);
      }
      const attributeValue = {
        ...res.data.data[0],
        associated_category: {},
        abs_constraints: {},
        attribute_value: {},
        constraints: {},
      }
      attributeValue.associated_category.data = await getAssociatedCategoriesByAttributeID(editingItem.id)
      const absConstraints = await getAbsConstraintsByAttributeID(editingItem.id, 10, undefined, undefined)
      attributeValue.abs_constraints.data = absConstraints.constraints
      const { attribute_values, count } = (await listAttributeValuesByAttributeID(editingItem.id, 10, undefined, undefined))
      attributeValue.attribute_value.data = attribute_values
      attributeValue.attribute_value_count = count
      attributeValue.constraints.data = generateAttributeConstraintObject(await getConstraintsByAttributeID(editingItem.id))
      if (attributeValue.abs_constraints.data.abs_enabled == null) {
        attributeValue.abs_constraints.data.abs_enabled = false
      }
      setAttributeDetail(attributeValue);
      setAttributeDetailCopy(attributeValue);
      setFinalAttributeConstraint(attributeValue.constraints.data)

      // setDisableButtons(true);
      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while fetching details, Please try after some time.",
      });
    }
  }

  useEffect(() => {
    const validation = Utils.validate(attributeDetail, validationOptions);
    const { abs_constraints, constraints } = attributeDetail;

    // validation check for disabling save button
    if (
      !validation[0] ||
      (JSON.stringify(prevSelectedCategory) ===
        JSON.stringify(selectedCategory) &&
        JSON.stringify(attributeDetail) ===
        JSON.stringify(attributeDetailCopy) &&
        (finalABSValue === null ||
          JSON.stringify(abs_constraints?.data) ===
          JSON.stringify(finalABSValue)) &&
        finalAttributeValues.length === 0 &&
        constraints?.data &&
        JSON.stringify(constraints.data) ===
        JSON.stringify(finalAttributeConstraint))
    ) {
      setDisableButtons(true);
    } else {
      setDisableButtons(false);
    }

    if (finalABSValue) {
      // setDisableButtons(false);
    }

    if (finalAttributeValues) {
      // setDisableButtons(false);
    }

    if (selectedCategory) {
      // setDisableButtons(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributeDetail, finalABSValue, finalAttributeValues, selectedCategory]);

  async function hande_change(e) {
    let temp = JSON.parse(JSON.stringify(attributeDetail));

    temp[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setAttributeDetail(temp);
  }

  async function save_changes() {
    setAttributeResponse(null);
    setDisableButtons(true);

    setLoadingInfo({
      status: "Saving",
      message: "Saving changes",
    });

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;

    let final_url = `${api_base_url}attribute/edit/${editingItem.id}`;
    if (editingItem.id === "0" || editingItem.form === "duplicate") {
      final_url = `${api_base_url}attribute/create`;
    }
    if (finalAttributeConstraint && finalAttributeConstraint.validation_type) {
      finalAttributeConstraint.validation_type = "LOV";
    }
    attributeDetail.abs_constraints = finalABSValue;
    attributeDetail.cf_constraints = finalCFValue;
    attributeDetail.constraints = finalAttributeConstraint;
    attributeDetail.attribute_value = {
      data: finalAttributeValues,
      industry_id: industryId,
    };

    attributeDetail.industry_id = industryId;

    let newlyDeleted = [];
    let newlyAdded = [...selectedCategory];

    if (prevSelectedCategory && prevSelectedCategory.length > 0) {
      prevSelectedCategory.map((item) => {
        let index = newlyAdded.findIndex((att) => att.id === item.id);
        if (index === -1) {
          let { id } = item;
          newlyDeleted.push({ id });
        } else {
          newlyAdded.splice(index, 1);
        }
        return null;
      });
    }

    let newIds = newlyAdded.map((a) => a.id);
    let deletedIds = newlyDeleted.map((a) => a.id);
    let data = {
      delete_category: deletedIds,
      add_category: newIds,
      industry_id: industryId,
    };
    attributeDetail.associated_category = data;

    let final_details = {
      ...attributeDetail,
    };

    let res = await ServiceWrapper.doPost(
      final_url,
      final_details,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      setAttributeResponse(res.data);
      if (!res.data.done) {
        toast.error(res.data.error_message);
        setTimeout(() => {
          editingItem.id === "0"
            ? setEditingItem(null)
            : setEditingItem({
              form: "view",
              id: attributeDetail.id,
            });
          setDisableButtons(false);
        }, 2000);

        return;
      }
      handleResponseMessages(res.data);

      if (editingItem.id === "0" || editingItem.form === "duplicate") {
        setAttributeDetail(initialStateObject);
        setAttributeDetailCopy(initialStateObject);
        setDisableButtons(false);
        attributeContextData.setNewAttributeId(res?.data?.id ?? "");
        handle_reload_list(res?.data?.id);
      } else {
        setTimeout(() => {
          editingItem.id === "0"
            ? setEditingItem(null)
            : setEditingItem({
              form: "view",
              id: attributeDetail.id,
            });
          setDisableButtons(false);
        }, 2000);
        attributeContextData.setUpdatedAttributeId(attributeDetail?.id ?? "");
        setAttributeDetailCopy(attributeDetail);
        handle_reload_list(attributeDetail.id);
      }
    } else {
      toast.error("Something went wrong, Please try after some time.");
      setTimeout(() => {
        editingItem.id === "0"
          ? setEditingItem(null)
          : setEditingItem({
            form: "view",
            id: attributeDetail.id,
          });
        setDisableButtons(false);
      }, 2000);
    }
    setLoadingInfo({
      status: "",
      message: "",
    });
  }

  function handleResponseMessages(response) {
    let attributeValue = response.attribute_value;
    let constraints = response.constraints;
    let absConstraints = response.abs_constraints;
    let associatedCategory = response.associated_category;
    let error_flag = false;
    if (attributeValue) {
      if (!attributeValue.done) {
        toast.error(attributeValue.error_message);
        error_flag = true;
      }
    }

    if (constraints) {
      if (!constraints.done) {
        toast.error(constraints.error_message);
        error_flag = true;
      }
    }

    if (absConstraints) {
      if (!absConstraints.done) {
        toast.error(absConstraints.error_message);
        error_flag = true;
      }
    }

    if (associatedCategory) {
      if (!associatedCategory.done) {
        toast.error(associatedCategory.error_message);
        error_flag = true;
      }
    }
    if (!error_flag) {
      if (editingItem.id === "0" || editingItem.form === "duplicate") {
        toast.success("Attribute Created Successfully");
      } else {
        toast.success("Attribute Updated Successfully");
      }
    }
  }

  function handle_reload_list(id) {
    // if (
    //   !(
    //     attributeDetail.name === attributeDetailCopy.name &&
    //     attributeDetail.active === attributeDetailCopy.active
    //   )
    // ) {

    // }
    setListReloadCounter((n) => n + 1);
    setTimeout(() => {
      attributeContextData.setEditingItem({
        form: "view",
        id: id,
      });
    }, 1000);
  }

  useEffect(() => {
    if (editingItem.form === "edit" || editingItem.form === "duplicate") {
      if (editingItem.id === "0") {
        setAttributeDetail(initialStateObject);
        setAttributeDetailCopy(initialStateObject);
      } else {
        load_attribute_detail();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem]);

  useEffect(() => {
    if (editingItem.id === "0") {
      setAttributeDetail(initialStateObject);
      setAttributeDetailCopy(initialStateObject);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem.id]);

  const handleOnSaveClick = () => {
    if (appContext.pm.checkPermission("gmsattributes_update")) {
      save_changes();
    } else {
      toast.info("You do not have permission to save the attributes");
    }
  }

  const handleOnCancelClick = () => {
    editingItem.id === "0" ? setEditingItem({ form: "view", id: attributeId, }) : setEditingItem({ form: "view", id: attributeDetail.id, });
  }

  return (
    <React.Fragment>
      {editingItem.form === "view" ? (
        <AttributeDetails
          attributeResponse={attributeResponse}
          setAttrListApiCompleted={setAttrListApiCompleted}
        />
      ) : (
        <>
          {loading.status === "Loading" && (
            <div className="p-3 ms-3">
              <div className="p-1 mb-4 col-3 skeleton"></div>
              <div className="p-3 border rounded-1">
                <div className="row">
                  <div className="col-6">
                    <div className="p-3 col-8 skeleton"></div>
                  </div>
                  <div className="pb-3 col-6 justify-content-end row">
                    <div className="p-1 mt-0 col-3 skeleton"></div>
                  </div>
                </div>
                <div className="p-2 mt-4 mb-4 skeleton text50"></div>
                <div className="p-4 mt-4 skeleton text50"></div>
              </div>
              <br />
              <div className="p-3 mb-4 col-11 skeleton"></div>
              <div className="p-3 mb-4 col-11 skeleton"></div>
              <div className="p-3 mb-4 col-11 skeleton"></div>
              <div className="p-3 mb-4 col-11 skeleton"></div>
            </div>
          )}

          {loading.status !== "Loading" && (
            <>
              <div className="pt-1 mb-3 border-0 rounded shadow-none bg-body ps-3">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item tw-pointer-events-none">
                      <Link to="#">
                        <Label
                          message="Taxonomy"
                          fontSize={0.75}
                          fontWeight="400"
                          color="#5c5f62"
                        />
                      </Link>
                    </li>
                    <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
                      <Label
                        message="Attributes"
                        fontSize={0.75}
                        fontWeight="500"
                        color="#5c5f62"
                      />
                    </li>
                    <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
                      <Label
                        message={loading.status === "Success" && attributeDetail ? attributeDetail.name : ""}
                        fontSize={"0.75"}
                        fontWeight="500"
                        color="#5c5f62"
                      />
                    </li>
                  </ol>
                </nav>
                <div className="p-3 mb-4 rounded card border-1 me-3">
                  <div className="d-flex justify-content-between">
                    <div>
                      <Label
                        message={`${editingItem.id === "0"
                            ? "Create "
                            : `${editingItem.form === "duplicate"
                              ? "Duplicate "
                              : "Edit"
                            }`
                          } Attribute`}
                        fontSize={1.125}
                        fontWeight="600"
                      />
                      {editingItem.id !== "0" && (
                        <>
                          {" "}
                          <br />
                          <Label
                            message={`UID: ${editingItem.id !== "0" ? editingItem.id : ""
                              }`}
                            fontSize={0.7}
                            fontWeight="400"
                            color="#5c5f62"
                          />{" "}
                        </>
                      )}
                    </div>
                    <div className="tw-flex tw-gap-3">
                      <button onClick={handleOnCancelClick} className="samll-outline-btn">Cancel</button>
                      {/* disabled={disableButtons} */}
                      <button onClick={handleOnSaveClick} className="small-filled-btn">Save</button>
                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <form>
                    <div className="mb-3">
                      <div className="col-12">
                        <Label message="Name " fontSize={0.8} htmlFor="name" />
                      </div>

                      <div className="col-7">
                        <input
                          type="text"
                          className="shadow-none form-control"
                          id="name"
                          name="name"
                          style={{
                            fontSize: "0.8rem",
                            color: "black",
                            fontWeight: "500",
                            fontFamily: "Noto Sans",
                            border: `1px solid ${attributeDetail?.name?.length > 2
                                ? "#ced4da"
                                : "#c13e25"
                              }`,
                          }}
                          placeholder="Enter Attribute Name"
                          value={attributeDetail.name}
                          onChange={(e) => hande_change(e)}
                          aria-describedby="nameHelp"
                          maxLength="60"
                          minLength="2"
                        />
                      </div>
                      <div id="nameHelp" className="form-text col-12">
                        <Label
                          message="Name must be 2-60 characters long, contain letters,
                      numbers and spaces, and must not contain special
                      characters."
                          fontSize={0.7}
                          fontWeight="600"
                          color="#B0B0B0"
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <Label
                        message="Description "
                        fontSize={0.8}
                        htmlFor="description"
                      />
                      <div className="col-7">
                        <textarea
                          className="shadow-none form-control"
                          id="description"
                          name="description"
                          rows="5"
                          style={{ fontSize: "0.8rem", fontWeight: "600" }}
                          placeholder="Enter description"
                          onChange={(e) => hande_change(e)}
                          value={attributeDetail.description}
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div className="me-3">
                  <Category
                    existingCategory={
                      attributeDetail.associated_category === undefined
                        ? []
                        : attributeDetail.associated_category.data
                    }
                    attributeId={editingItem.id === "0" ? null : editingItem.id}
                    setSelectedCategory={setSelectedCategory}
                    setAssociatedCategory={setAssociatedCategory}
                    setPrevSelectedCategory={setPrevSelectedCategory}
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.associated_category &&
                      attributeResponse.associated_category.done
                    }
                  />
                </div>
                <br />
                <div className="me-3">
                  <AttributeValues
                    aDetail={attributeDetail.attribute_value}
                    finalAttributeValues={finalAttributeValues}
                    setFinalAttributeValues={setFinalAttributeValues}
                    attributeValueCount={attributeDetail.attribute_value_count}
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.attribute_value &&
                      attributeResponse.attribute_value.done
                    }
                  />
                </div>
                <br />
                <div className="me-3">
                  {editingItem.id !== "0" ? (
                    <ABS
                      finalABSValue={finalABSValue}
                      setFinalABSValue={setFinalABSValue}
                      setFinalCFValue={setFinalCFValue}
                      attributeValueCount={attributeDetail.attribute_value_count}
                      title={ABS_SELECTION}
                      id="Abs"
                    />
                  ) :
                    null
                  }
                </div>
                {editingItem.id !== "0" && <br />}
                <div className="me-3">
                  <AttributeConstraint
                    finalattributeConstraint={finalAttributeConstraint}
                    setFinalAttributeConstraint={setFinalAttributeConstraint}
                    constraintModel={
                      attributeDetail.constraints &&
                      attributeDetail.constraints.data
                    }
                    saveMessage={
                      attributeResponse &&
                      attributeResponse.constraints &&
                      attributeResponse.constraints.done
                    }
                  />
                </div>
                {editingItem.id !== "0" && <br />}
                <div className="me-3">
                  {editingItem.id !== "0" ? (
                    <ABS
                      finalCFValue={finalCFValue}
                      setFinalABSValue={setFinalABSValue}
                      setFinalCFValue={setFinalCFValue}
                      attributeValueCount={attributeDetail.attribute_value_count}
                      title={CF_SELECTION}
                      id="Cf"
                    />
                  ) :
                    null
                  }
                </div>
                <div className="float-start">
                  <LoadingSuccessErrorAlert loading={loadingInfo} />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </React.Fragment>
  );
}

export default AddEditViewAttr;